import React from 'react';
import './genres.css';

import Button from 'react-bootstrap/Button';

export default class Genres extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
			//genres: this.props.genres,
			limit: this.props.limit || 100000000,
		};
  };

	async componentDidMount() {
	}

	componentWillUnmount() {
	}

	render() {

		let genres = [];
		if( this.props.genres ) {
			genres = this.props.genres;
			if( !Array.isArray(genres) ) {
				if( this.props.genres.length > 0 ) {
					genres = genres.split(',');
				} else {
					genres = [];
				}
			}
		}

		switch(this.props.template) {
			case 2:
				return (
					<>
						{(genres && genres.length > 0 ) &&
							Object.keys(genres).map((f,j) => {
								if( j < this.state.limit ) {
									return (
										<span key={j} className="" > - {genres[f]}</span>
									)
								}
							})
						}
					</>
				)
			case 1:
				return (<></>)
			default:
				return (
					<div className="genres">
						{(genres && genres.length > 0 ) &&
							Object.keys(genres).map((f,j) => {
								if( j < this.state.limit ) {
									return (
										<span key={j} className="btn btn-sm btn-genres" >{genres[f]}</span>
									)
								}
							})
						}
					</div>
				)
		}
	}
}

